<script>
import ProductFeature from "@js/components/Sections/Product/Components/ProductFeature.vue";
import CallbackButton from "@js/components/Buttons/CallbackButton.vue";
import {useProductStore} from "@js/store/ProductStore.js";
import NumberFormatComponent from "@js/components/Formatter/NumberFormatComponent.vue";
import ProductAddToCart from "@js/components/Sections/Product/Components/ProductAddToCart.vue";

export default {
    name: "ProductInfo",
    components: {ProductAddToCart, NumberFormatComponent, CallbackButton, ProductFeature},
    setup() {
        const productStore = useProductStore()

        return {productStore}
    }
}
</script>

<template>
    <div class="flex flex-col md:flex-row mb-2">
        <h1 class="flex items-center text-2xl md:text-3xl font-bold">
            {{ productStore.product.name }}
        </h1>
        <div class="flex items-center">
            <div :class="[productStore.product.available ? 'bg-emerald-700' : 'bg-red-600' ]"
                 class="ms-0 md:ms-2 font-bold text-[11px] text-white px-3 py-0.5 rounded leading-5">
                {{ productStore.product.available ? 'В наличии' : 'Нет в наличии' }}
            </div>
            <div v-if="productStore.product.bestseller"
                 class="ms-2 font-bold text-[11px] text-white px-3 py-0.5 rounded bg-[#c52314] leading-5">
                ХИТ Продаж
            </div>
        </div>
    </div>
    <hr class="mb-5 mt-5"/>
    <div class="flex flex-col gap-1 max-w-[400px] mb-5">
        <ProductFeature v-if="productStore.product.length"
                        :description="productStore.product.length"
                        title="Длина, мм"/>
        <ProductFeature v-if="productStore.product.width"
                        :description="productStore.product.width"
                        title="Ширина, мм"/>
        <ProductFeature v-if="productStore.product.height"
                        :description="productStore.product.height"
                        title="Высота, мм"/>
        <ProductFeature v-if="productStore.product.weight"
                        :description="productStore.product.weight"
                        title="Вес, т"/>
    </div>
    <hr class="mb-5"/>
    <div class="mb-5">
        <div class="text-xl md:text-2xl font-bold flex items-center">
            Цена:
            <div class="ms-2">
                <template v-if="productStore.product.price">
                    <NumberFormatComponent :number="productStore.product.price" append_text=" ₽"/>
                </template>
                <template v-else>
                    Договорная
                </template>
            </div>
        </div>
    </div>
    <div class="mb-5">
        <ProductAddToCart/>
    </div>
</template>

<style scoped lang="scss">

</style>
